var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconFilter(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    width: "100%",
    height: "100%",
    overflow: "visible",
    style: {
      display: "block"
    },
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M6.33309 12.3333C6.33304 12.4572 6.3675 12.5787 6.43262 12.6841C6.49774 12.7895 6.59094 12.8746 6.70176 12.93L8.03509 13.5967C8.13676 13.6475 8.24972 13.6714 8.36326 13.6663C8.47679 13.6612 8.58712 13.6271 8.68378 13.5673C8.78044 13.5075 8.8602 13.424 8.91551 13.3247C8.97081 13.2254 8.99981 13.1137 8.99976 13V8.33333C8.99991 8.00292 9.12274 7.68433 9.34443 7.43933L14.1598 2.11333C14.2461 2.01771 14.3028 1.89912 14.3232 1.77192C14.3435 1.64472 14.3265 1.51435 14.2744 1.39658C14.2222 1.27881 14.137 1.17868 14.0291 1.1083C13.9212 1.03792 13.7952 1.0003 13.6664 1H1.66643C1.5375 1.00005 1.41135 1.03748 1.30326 1.10776C1.19517 1.17804 1.10978 1.27815 1.05743 1.39598C1.00508 1.5138 0.988017 1.64427 1.00831 1.77159C1.0286 1.89892 1.08538 2.01762 1.17176 2.11333L5.98843 7.43933C6.21012 7.68433 6.33294 8.00292 6.33309 8.33333V12.3333Z",
    stroke: "var(--stroke-0, #717182)",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFilter);
export default __webpack_public_path__ + "static/media/icon-filter.272a6c2a824ed48cb17261b157440f47.svg";
export { ForwardRef as ReactComponent };